

import React, { useEffect, useRef } from "react";
import "../styles/testimonials.css";

const testimonials = [
  {
    name: "Dheeraj Kumar Choudhary",
    text:
      "Concerted-Path gave me the support and confidence to grow both personally and professionally.",
    work: "Working with: Genpact, Noida",
  },
  {
    name: "Om Prakash Singh",
    text:
      "In six months I developed myself a lot. Numerous opportunities helped me grow and better myself.",
    work: "Working with: Jindal Group, Delhi",
  },
  {
    name: "Sushil Kumar Pandit",
    text:
      "Concerted Path supported my aspirations to succeed both personally and professionally.",
    work: "Working with: Beeta Logistics, Gurugram",
  },
  {
    name: "Suraj Goswami",
    text:
      "Training course at Concerted-Path has been a breathtaking experience. Strong support from faculty and mentors.",
    work: "Self Made Entrepreneur, Delhi",
  },
  {
    name: "Gaurav Kr Roy",
    text:
      "Trainers and counsellors provided great support. Interactive video lecture programs were excellent.",
    work: "Working with: Jindal Steel, Gurugram",
  },
  {
    name: "Dilip Kumar Shahi",
    text:
      "The CPAE program helped me excel through practical knowledge. I am now working as a Tax Consultant and Trainer.",
    work: "Tax Consultant & Trainer",
  },
];

export default function Testimonials() {
  const sliderRef = useRef(null);

  const scrollByCard = (direction = 1) => {
    if (!sliderRef.current) return;

    const slider = sliderRef.current;
    const cardWidth = slider.children[0].offsetWidth + 32;

    slider.scrollBy({
      left: cardWidth * direction,
      behavior: "smooth",
    });
  };

  /* AUTO SLIDE */
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const interval = setInterval(() => {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

      if (slider.scrollLeft >= maxScrollLeft - 10) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        scrollByCard(1);
      }
    }, 4500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        {/* TITLE */}
        <h2 className="testimonials-title">
          What Our <span>Students Say</span>
        </h2>

        {/* SLIDER */}
        <div className="testimonials-slider-wrapper">
          <div className="testimonials-slider" ref={sliderRef}>
            {testimonials.map((t, idx) => (
              <article key={idx} className="testimonial-card">
                <p className="testimonial-text">“{t.text}”</p>

                <div className="testimonial-footer">
                  <h4 className="testimonial-name">{t.name}</h4>
                  <span className="testimonial-work">{t.work}</span>
                </div>

                <div className="testimonial-stars">★★★★★</div>
              </article>
            ))}
          </div>

          {/* NAV BUTTONS */}
          <div className="testimonial-nav">
            <button onClick={() => scrollByCard(-1)}>‹</button>
            <button onClick={() => scrollByCard(1)}>›</button>
          </div>
        </div>
      </div>
    </section>
  );
}
